import {
  GET_TRANSACTION_DETAILS_START,
  GET_TRANSACTION_DETAILS_SUCCESS,
  GET_TRANSACTION_DETAILS_ERROR,
  DOWNLOAD_FILE_REQUEST,
  DOWNLOAD_FILE_SUCCESS,
} from "Constant";

const initialState = {
  loading: false,
  data: [],
};
export default function TransactionDetailsReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case GET_TRANSACTION_DETAILS_START:
      return {
        ...state,
        loading: true,
      };
    case GET_TRANSACTION_DETAILS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };

    case GET_TRANSACTION_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case DOWNLOAD_FILE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DOWNLOAD_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
